import {Component, EventEmitter, Input, Output} from '@angular/core';

import {BDCPConstsService} from '../../services/consts.service';
import {BDCPProduct} from '../../../../models/product.model';
import {IBDCPFolderService} from '../../services/folder-service/folder.interface';
import {Router} from '@angular/router';

@Component({
    selector: 'bdcp-product-result',
    templateUrl: './product-result.component.html',
    styleUrls: ['./product-result.component.scss']
})
export class BDCPProductResultComponent {

    @Input() public product: BDCPProduct;
    @Input() public isBrotherProduct: boolean;
    @Input() public bookmarkMode: boolean;
    @Output() public deleteProductFromFolder = new EventEmitter<void>();

    public constructor(
        public consts: BDCPConstsService,
        public folderService: IBDCPFolderService,
        private router: Router
    ) {
    }

    public showDetails(): void {
        this.router.navigate(['/products', 'product-details', this.product.manufacturerSKU]);
    }

    public async findAlternatives() {
        await this.router.navigate([
            '/products', 'product-finder', 'alternatives', this.product.puid ]);
    }

    public blocked(): boolean {
        return this.consts.blockedAlternativeTypeNames.some(
            t => t.toLowerCase().trim() === this.product.productTypeName.toLowerCase().trim()
        );
    }
}
